/* Capitol style — trang sản phẩm (sections/gv-product.liquid), như GovMint:
   - Ảnh: mũi tên 2 bên, ảnh nhỏ bên dưới (máy tính), chấm tròn + vuốt (điện thoại).
   - Bấm ảnh: xem toàn màn hình (phóng to / thu nhỏ, mũi tên, ảnh nhỏ hoặc chấm), Esc hoặc X để đóng.
   - Qty – / +, chọn phiên bản (nếu có), ngày gửi hàng dự kiến (nếu bật).
   - 3 thẻ DETAILS / MORE INFORMATION / REVIEWS (điện thoại: gập mở).
   - Hàng sản phẩm gợi ý trong DETAILS: tải sau khi trang xong (không làm chậm trang). */
(function () {
  if (window.__gvProduct) return; window.__gvProduct = 1;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = matchMedia('(max-width: 768px)');
  function beh() { return reduce.matches ? 'auto' : 'smooth'; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function clamp(i, n) { return Math.max(0, Math.min(n - 1, i)); }
  function loadImg(im) { if (im && im.dataset.src) { im.src = im.dataset.src; im.removeAttribute('data-src'); } }

  /* ---------- Ảnh chính ---------- */
  function gallery(root) {
    var track = root.querySelector('.gvp__track');
    var api = { cur: 0, go: function () {} };
    if (!track) return api;
    var n = track.children.length;
    var thumbBox = root.querySelector('.gvp__thumbs');
    var thumbs = root.querySelectorAll('.gvp__thumbs .gvp__thumb');
    var dots = root.querySelectorAll('.gvp__dots .gvp__dot');
    var prev = root.querySelector('.gvp__arrow--prev'), next = root.querySelector('.gvp__arrow--next');
    function mark(i) {
      api.cur = i;
      each(thumbs, function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      each(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', i === n - 1 ? 'true' : 'false');
      var t = thumbs[i];
      if (t && thumbBox) {
        var l = t.offsetLeft - thumbBox.offsetLeft, r = l + t.offsetWidth;
        if (l < thumbBox.scrollLeft) thumbBox.scrollTo({ left: l, behavior: beh() });
        else if (r > thumbBox.scrollLeft + thumbBox.clientWidth) thumbBox.scrollTo({ left: r - thumbBox.clientWidth, behavior: beh() });
      }
    }
    /* Đang trượt tới 1 ảnh (bấm mũi tên / ảnh nhỏ): giữ đích, không nhận vị trí giữa chừng */
    var target = -1;
    api.go = function (i, instant) {
      i = clamp(i, n);
      target = instant ? -1 : i;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : beh() });
      mark(i);
    };
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (target >= 0) { if (Math.abs(track.scrollLeft - target * track.clientWidth) < 2) target = -1; return; }
        var i = clamp(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), n); if (i !== api.cur) mark(i);
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { target = -1; }, { passive: true }); });
    if (prev) prev.addEventListener('click', function () { if (api.cur > 0) api.go(api.cur - 1); });
    if (next) next.addEventListener('click', function () { if (api.cur < n - 1) api.go(api.cur + 1); });
    each(thumbs, function (t) { t.addEventListener('click', function () { api.go(+t.dataset.index); }); });
    /* Đổi cỡ màn hình: giữ đúng ảnh đang xem */
    if ('ResizeObserver' in window) new ResizeObserver(function () { track.scrollLeft = api.cur * track.clientWidth; }).observe(track);
    mark(0);
    return api;
  }

  /* ---------- Xem toàn màn hình ---------- */
  function viewer(root, gal) {
    var dlg = root.querySelector('[data-gvp-fs]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var ft = dlg.querySelector('.gvp__fs-track'), slides = ft.children, n = slides.length;
    var thumbs = dlg.querySelectorAll('.gvp__fs-thumbs .gvp__thumb'), dots = dlg.querySelectorAll('.gvp__fs-dots .gvp__dot');
    var prev = dlg.querySelector('.gvp__fs-prev'), next = dlg.querySelector('.gvp__fs-next');
    var zin = dlg.querySelector('[data-fs-zoom="1"]'), zout = dlg.querySelector('[data-fs-zoom="-1"]');
    var closeBtn = dlg.querySelector('[data-fs-close]');
    var html = document.documentElement, cur = 0, zoom = 1, ZMAX = 3;
    function frame(i) { return slides[i] && slides[i].querySelector('.gvp__fs-frame'); }
    function setZoom(z) {
      var f = frame(cur); if (!f) return;
      var img = f.querySelector('img');
      var cx = (f.scrollLeft + f.clientWidth / 2) / Math.max(1, f.scrollWidth), cy = (f.scrollTop + f.clientHeight / 2) / Math.max(1, f.scrollHeight);
      zoom = Math.max(1, Math.min(ZMAX, z));
      img.style.width = img.style.height = zoom === 1 ? '' : (zoom * 100) + '%';
      dlg.classList.toggle('is-zoomed', zoom > 1);
      f.scrollLeft = cx * f.scrollWidth - f.clientWidth / 2;
      f.scrollTop = cy * f.scrollHeight - f.clientHeight / 2;
      if (zin) zin.setAttribute('aria-disabled', zoom >= ZMAX ? 'true' : 'false');
      if (zout) zout.setAttribute('aria-disabled', zoom <= 1 ? 'true' : 'false');
    }
    function mark(i) {
      if (i !== cur && zoom > 1) setZoom(1);
      cur = i;
      for (var k = i - 1; k <= i + 1; k++) if (slides[k]) loadImg(slides[k].querySelector('img'));
      each(thumbs, function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      each(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', i === n - 1 ? 'true' : 'false');
    }
    var target = -1;
    function go(i, instant) {
      i = clamp(i, n);
      if (zoom > 1) setZoom(1);
      target = instant ? -1 : i;
      ft.scrollTo({ left: i * ft.clientWidth, behavior: instant ? 'auto' : beh() });
      mark(i);
    }
    function open(i) {
      each(thumbs, function (t) { loadImg(t.querySelector('img')); });
      dlg.showModal();
      html.setAttribute('scroll-lock', '');
      cur = -1; zoom = 1; setZoom(1);
      go(i, true);
      if (closeBtn) closeBtn.focus();
    }
    dlg.addEventListener('close', function () {
      html.removeAttribute('scroll-lock');
      if (zoom > 1) setZoom(1);
      gal.go(cur, true);
    });
    each(root.querySelectorAll('.gvp__zoom'), function (b) { b.addEventListener('click', function () { open(+b.dataset.index); }); });
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
    if (prev) prev.addEventListener('click', function () { if (cur > 0) go(cur - 1); });
    if (next) next.addEventListener('click', function () { if (cur < n - 1) go(cur + 1); });
    if (zin) zin.addEventListener('click', function () { setZoom(zoom + 1); });
    if (zout) zout.addEventListener('click', function () { setZoom(zoom - 1); });
    each(thumbs, function (t) { t.addEventListener('click', function () { go(+t.dataset.fsIndex); }); });
    dlg.addEventListener('keydown', function (e) {
      if (zoom > 1) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); if (cur > 0) go(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); if (cur < n - 1) go(cur + 1); }
    });
    var raf = 0;
    ft.addEventListener('scroll', function () {
      if (raf || zoom > 1) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (target >= 0) { if (Math.abs(ft.scrollLeft - target * ft.clientWidth) < 2) target = -1; return; }
        var i = clamp(Math.round(ft.scrollLeft / Math.max(1, ft.clientWidth)), n); if (i !== cur) mark(i);
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { ft.addEventListener(ev, function () { target = -1; }, { passive: true }); });
    /* Kéo ảnh khi đang phóng to (chuột) */
    var drag = null;
    ft.addEventListener('pointerdown', function (e) {
      if (zoom === 1 || e.pointerType !== 'mouse' || e.button !== 0) return;
      var f = frame(cur); drag = { f: f, x: e.clientX, y: e.clientY, l: f.scrollLeft, t: f.scrollTop }; e.preventDefault();
    });
    addEventListener('pointermove', function (e) { if (drag) { drag.f.scrollLeft = drag.l - (e.clientX - drag.x); drag.f.scrollTop = drag.t - (e.clientY - drag.y); } });
    addEventListener('pointerup', function () { drag = null; });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (dlg.open && zoom === 1) ft.scrollLeft = cur * ft.clientWidth; }).observe(ft);
  }

  /* ---------- Qty – / + ---------- */
  function qty(root) {
    var inp = root.querySelector('[data-gvp-qty]'); if (!inp) return;
    function fix(v) {
      var min = parseInt(inp.min, 10) || 1, step = parseInt(inp.step, 10) || 1, max = inp.max ? parseInt(inp.max, 10) : Infinity;
      if (isNaN(v) || v < min) v = min;
      v = min + Math.round((v - min) / step) * step;
      if (v > max) v = max - ((max - min) % step);
      return v;
    }
    each(root.querySelectorAll('.gvp__qty-btn'), function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(inp.step, 10) || 1;
        inp.value = fix((parseInt(inp.value, 10) || 0) + step * +b.dataset.step);
      });
    });
    inp.addEventListener('change', function () { inp.value = fix(parseInt(inp.value, 10)); });
    var form = inp.form;
    if (form) form.addEventListener('submit', function () { inp.value = fix(parseInt(inp.value, 10)); }, true);
  }

  /* ---------- Ngày gửi hàng dự kiến (ngày làm việc T2–T6) ---------- */
  function shipText(el) {
    var d = new Date(), n = parseInt(el.dataset.days, 10) || 0;
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    function p2(x) { return (x < 10 ? '0' : '') + x; }
    el.textContent = el.dataset.label + ' ' + p2(d.getMonth() + 1) + '/' + p2(d.getDate()) + '/' + d.getFullYear();
  }

  /* ---------- Chọn phiên bản ---------- */
  function variants(root, gal) {
    var data = root.querySelector('[data-gvp-variants]'); if (!data) return;
    var list; try { list = JSON.parse(data.textContent); } catch (e) { return; }
    var sels = root.querySelectorAll('[data-gvp-option]');
    var price = root.querySelector('[data-gvp-price]'), stock = root.querySelector('[data-gvp-stock]');
    var ship = root.querySelector('[data-gvp-ship]'), sku = root.querySelector('[data-gvp-sku]');
    var btn = root.querySelector('[data-gvp-atc]'), qin = root.querySelector('[data-gvp-qty]');
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function update() {
      var opts = Array.prototype.map.call(sels, function (s) { return s.value; });
      var v = null;
      for (var i = 0; i < list.length; i++) if (list[i].options.join('\u0001') === opts.join('\u0001')) { v = list[i]; break; }
      var ok = !!(v && v.available);
      if (v) {
        each(root.querySelectorAll('[data-gvp-id]'), function (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); });
        if (price) price.innerHTML = (v.compare ? '<span class="gv-sr-only">' + esc(price.dataset.srReg) + '</span><s class="gvp__was">' + esc(v.compare) + '</s><span class="gv-sr-only">' + esc(price.dataset.srSale) + '</span>' : '') + '<span class="gvp__now">' + esc(v.price) + '</span>';
        if (sku) { sku.hidden = !v.sku; sku.textContent = sku.dataset.label + ' ' + v.sku; }
        if (qin) { qin.min = v.min || 1; if ((parseInt(qin.value, 10) || 0) < qin.min) qin.value = qin.min; }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        if (v.media) {
          var sl = root.querySelectorAll('.gvp__slide');
          for (var k = 0; k < sl.length; k++) if (sl[k].dataset.mediaId === String(v.media)) { gal.go(k); break; }
        }
      }
      if (stock) { stock.textContent = ok ? stock.dataset.in : stock.dataset.out; stock.classList.toggle('is-out', !ok); }
      if (ship) ship.hidden = !ok;
      if (btn) {
        btn.disabled = !ok;
        var t = btn.querySelector('.gv-deal__btn-t');
        if (t && !btn.classList.contains('is-busy')) t.textContent = ok ? btn.dataset.add : btn.dataset.sold;
      }
    }
    each(sels, function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Thẻ (máy tính) / gập mở (điện thoại) ---------- */
  function tabs(root) {
    var box = root.querySelector('[data-gvp-tabs]'); if (!box) return;
    /* Khung Ryviu tự gắn: nếu store không bật app Ryviu (không có script Ryviu) thì bỏ mục Reviews cho gọn */
    var ry = box.querySelector('[data-gvp-ryviu]');
    if (ry && !document.querySelector('script[src*="ryviu"]')) {
      ry.parentNode.removeChild(ry);
      each(root.querySelectorAll('[data-gvp-goto="reviews"]'), function (a) {
        var sp = document.createElement('span'); sp.className = a.className; sp.textContent = a.textContent; a.parentNode.replaceChild(sp, a);
      });
    }
    var tabBtns = box.querySelectorAll('.gvp__tab'), secs = box.querySelectorAll('.gvp__sec');
    var selected = 'details';
    function apply() {
      each(secs, function (sec) {
        var p = sec.querySelector('.gvp__panel');
        p.hidden = !sec.classList.contains('is-open');
        var b = sec.querySelector('.gvp__acc-btn'); if (b) b.setAttribute('aria-expanded', sec.classList.contains('is-open') ? 'true' : 'false');
      });
      each(tabBtns, function (b) {
        var on = b.dataset.tab === selected;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
    }
    function select(key, focus) {
      selected = key; apply();
      if (focus) each(tabBtns, function (b) { if (b.dataset.tab === key) b.focus(); });
    }
    each(tabBtns, function (b, i) {
      b.addEventListener('click', function () { select(b.dataset.tab); });
      b.addEventListener('keydown', function (e) {
        var k = -1, n = tabBtns.length;
        if (e.key === 'ArrowRight') k = (i + 1) % n; else if (e.key === 'ArrowLeft') k = (i - 1 + n) % n;
        else if (e.key === 'Home') k = 0; else if (e.key === 'End') k = n - 1;
        if (k < 0) return;
        e.preventDefault(); select(tabBtns[k].dataset.tab, true);
      });
    });
    each(box.querySelectorAll('.gvp__acc-btn'), function (b) {
      b.addEventListener('click', function () { b.closest('.gvp__sec').classList.toggle('is-open'); apply(); });
    });
    (mobile.addEventListener ? mobile.addEventListener('change', apply) : mobile.addListener(apply));
    /* "67 Reviews" dưới tên sản phẩm: mở thẻ đánh giá và cuộn tới */
    each(root.querySelectorAll('[data-gvp-goto]'), function (a) {
      a.addEventListener('click', function (e) {
        var key = a.dataset.gvpGoto, sec = box.querySelector('[data-sec="' + key + '"]'); if (!sec) return;
        e.preventDefault();
        sec.classList.add('is-open'); select(key);
        sec.scrollIntoView({ behavior: beh(), block: 'start' });
      });
    });
    apply();
  }

  /* ---------- Sản phẩm gợi ý (tải sau) ---------- */
  function recs(root) {
    var box = root.querySelector('[data-gvp-recs]'); if (!box || !box.dataset.url) return;
    function load() {
      fetch(box.dataset.url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (text) {
        if (!text) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var strip = doc.querySelector('[data-gvp-recs-ready]');
        if (!strip || !strip.querySelector('li')) return;
        box.innerHTML = '';
        if (box.dataset.title) {
          var h = document.createElement('h2'); h.className = 'gvp__recs-title'; h.textContent = box.dataset.title; box.appendChild(h);
        }
        box.appendChild(document.importNode(strip, true));
        box.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      }).catch(function () {});
    }
    function later() { ('requestIdleCallback' in window) ? requestIdleCallback(load, { timeout: 2500 }) : setTimeout(load, 800); }
    (document.readyState === 'complete') ? later() : addEventListener('load', later, { once: true });
  }

  /* ---------- Điện thoại: nút ADD TO CART dính đáy khi chỗ Qty + nút không nằm trọn trong màn hình (như GovMint) ---------- */
  function stickyBuy(root) {
    var slot = root.querySelector('[data-gvp-slot]'), box = root.querySelector('.gvp__buy');
    if (!slot || !box) return;
    var seen = true;
    function apply() { slot.classList.toggle('is-stuck', mobile.matches && !seen); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[es.length - 1].intersectionRatio >= 0.99; apply(); }, { threshold: [0, 0.5, 0.99, 1] }).observe(box);
    } else {
      var check = function () { var r = box.getBoundingClientRect(); seen = r.top >= 0 && r.bottom <= innerHeight; apply(); };
      addEventListener('scroll', check, { passive: true }); addEventListener('resize', check); check();
    }
    (mobile.addEventListener ? mobile.addEventListener('change', apply) : mobile.addListener(apply));
  }

  function init(root) {
    if (!root || root.__gvp) return; root.__gvp = 1;
    var gal = gallery(root);
    viewer(root, gal);
    qty(root);
    stickyBuy(root);
    var ship = root.querySelector('[data-gvp-ship]'); if (ship) shipText(ship);
    /* Trả góp: chỉ chừa khoảng cách khi Shopify thật sự hiện dòng trả góp */
    var terms = root.querySelector('[data-gvp-terms]');
    if (terms && 'ResizeObserver' in window) new ResizeObserver(function () { terms.classList.toggle('has-terms', terms.offsetHeight > 0); }).observe(terms);
    variants(root, gal);
    tabs(root);
    recs(root);
  }
  function scan(r) { each((r || document).querySelectorAll('[data-gvp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
